export const PILLARS = [
  { id: "safety", label: "الأمان النفسي" },
  { id: "emotion", label: "تنظيم المشاعر" },
  { id: "independence", label: "الاستقلالية" },
  { id: "communication", label: "التواصل" },
  { id: "social", label: "الكفاءة الاجتماعية" },
  { id: "selfworth", label: "قيمة الذات" },
  { id: "identity", label: "الهوية والقيم" },
  { id: "science", label: "الأساس العلمي" },
] as const;

export type PillarId = (typeof PILLARS)[number]["id"];
export const SCIENCE_LABEL = "الأساس العلمي";

export function pillarById(id: string) {
  return PILLARS.find((p) => p.id === id) ?? null;
}

const LABELS = new Set<string>(PILLARS.map((p) => p.label));

/** The post's pillars among the eight; none (or empty rakiza) counts as الأساس العلمي. */
export function postPillars(rakiza: unknown): string[] {
  const list = Array.isArray(rakiza) ? rakiza.filter((r): r is string => typeof r === "string") : [];
  const known = list.filter((r) => LABELS.has(r));
  return known.length ? known : [SCIENCE_LABEL];
}

export function primaryPillar(rakiza: unknown): string {
  return postPillars(rakiza)[0];
}

export function postInPillar(rakiza: unknown, id: string): boolean {
  const p = pillarById(id);
  return p ? postPillars(rakiza).includes(p.label) : false;
}
